import { getEditor, isEnabled } from '../composables/editorsMap';
import { Quote } from 'lucide-vue-next';
export const getBlockQuoteOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'block_quote'),
    icon: Quote,
    title: 'ציטוט',
    action: () => {
      let chain = editor?.chain().focus();
      if (!editor?.isActive('blockquote')) {
        chain = chain.addSpaceBefore(true);
      }
      return chain.toggleBlockquote().run();
    },
    isActive: () => editor?.isActive('blockquote'),
  };
};
